export default __webpack_public_path__ + "static/media/onboarding_factoring_notice_of_assignment.43573868.png";